import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

const getNotifications = async (page = '', filter = '', orderBy = 'createTime DESC,id') => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/notifications?pageSize=200&pageToken=${page}&filter=${filter}&orderBy=${orderBy}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

const deleteNotification = async notificationsIds => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/notifications`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'DELETE',
    body: JSON.stringify({
      ids: notificationsIds
    })
  }).then(res => API.generateResponse(res));
};

const archiveNotification = async notificationsIds => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/notifications:archive`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'PUT',
    body: JSON.stringify({
      ids: notificationsIds
    })
  }).then(res => API.generateResponse(res));
};

const getNotificationTypes = async () => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/notificationtypes`;
  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

export { getNotifications, deleteNotification, archiveNotification, getNotificationTypes };
